// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2cJCe","left":"InfoRow_left__1tYN9"};